import React from "react";
import { Row, Col } from "reactstrap";
import { ApplicationQuickMetrics } from "../../../..";
import AppMetricDisplay from "./AppMetricDisplay";

type Props = {
  metrics: ApplicationQuickMetrics;
};

export default class AppSummaryGridItem extends React.Component<Props> {
  render() {
    return (
      <Row>
        <Col sm={2}>{/* Should be empty to align with title */}</Col>
        <Col sm={10}>
          <AppMetricDisplay
            metricDescription="Total Number of Open Feature Requests"
            metricValue={`${this.props.metrics.numOpenFeatureRequests.toString()} / ${this.props.metrics.totalFeatureRequests.toString()}`}
          />
          <AppMetricDisplay
            metricDescription="Total Number of Open Bug Reports"
            metricValue={`${this.props.metrics.numOpenBugReports.toString()} / ${this.props.metrics.totalBugReports.toString()}`}
          />
          <AppMetricDisplay
            metricDescription="Total Number of Resource Requests"
            metricValue={`${this.props.metrics.numOpenResourceRequests.toString()} / ${this.props.metrics.totalResourceRequests.toString()}`}
            isHidden={!this.props.metrics.allowResourceRequest}
          />
        </Col>
      </Row>
    );
  }
}
